import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { UpdateContactInput } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { ContactDetailsForm } from "@/app/Contacts/Forms/ContactDetailsForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { contactValidation } from "@/app/Contacts/Forms/contactValidation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { useGqlMutation, useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { updateContactMutation } from "@/app/Contacts/GraphQL/contactMutations";
import { contactRecordQuery } from "../GraphQL/contactRecordQuery";
import { AddressInput } from "@/app/Address/Components/AddressInput";
import { mapAddressToInput } from "@/app/Address/Utils/mapAddressToInput";

type ContactEditDialogProps = {
  contactId: string;
};
export function ContactEditDialog({ contactId }: ContactEditDialogProps) {
  const { mutateAsync } = useGqlMutation(updateContactMutation);
  const { close } = useDialogState();
  const { data, isLoading } = useGqlQuery(contactRecordQuery, {
    id: contactId,
  });

  const contact = data?.contact;

  return (
    <BaseDialog title={`Update contact`} isLoading={isLoading}>
      {contact ? (
        <GenericForm<UpdateContactInput>
          validationSchema={toFormikValidationSchema(contactValidation)}
          initialValues={{
            name: contact.name,
            company_number: contact.company_number,
            legal_name: contact.legal_name,
            purchase_order_number: contact.purchase_order_number,
            billing_email: contact.billing_email,
            billing_phone: contact.billing_phone,
            billingAddress: {
              upsert: contact.billingAddress
                ? mapAddressToInput(contact.billingAddress)
                : null!,
            },
          }}
          onSubmit={async (values) => {
            await mutateAsync({
              id: contact.id,
              input: values,
            });

            await close();
          }}
        >
          <ContactDetailsForm contact={contact} />
          <FormDivider />
          <AddressInput
            name="billingAddress.upsert"
            label="Address"
            className="col-span-6"
            initialLat={contact.billingAddress?.lat}
            initialLng={contact.billingAddress?.lng}
          />
          <DialogSubmitButton text={"Add contact"} />
        </GenericForm>
      ) : null}
    </BaseDialog>
  );
}
